import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as popularPlaceActions from './../../../../../actions/popularPlaceAction';
import {uploadAction} from './../../../../../actions/uploadAction';
import PopularPlaceDetail from './PopularPlaceDetail';

const mapStateToProps = state => {
    return {
        popularPlaceState: state.popularPlaceReducer,
        uploadState: state.uploadReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPopularPlaceDetail: (id) => dispatch(popularPlaceActions.getPopularPlaceDetail(id)),
        setPopularPlaceDetail: (popularPlace) => dispatch(popularPlaceActions.setPopularPlaceDetail(popularPlace)),
        updatePopularPlace: (popularPlace) => dispatch(popularPlaceActions.updatePopularPlace(popularPlace)),
        createPopularPlace: (popularPlace) => dispatch(popularPlaceActions.createPopularPlace(popularPlace)),
        onUploadFile: (filters) => dispatch(uploadAction(filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(PopularPlaceDetail));
